/**
 * test input value is undefined or not
 * @param {*} value
 * @returns {boolean}
 */
export default function isUndefined(value) {
  return typeof value === 'undefined';
}
